<template>
<svg class="warehouse-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 17H4V9H16V17H18V6.35L10 3.15L2 6.35V17ZM0 19V5L10 1L20 5V19H14V11H6V19H0ZM7 19V17H9V19H7ZM9 16V14H11V16H9ZM11 19V17H13V19H11Z" fill="#26A69A"/>
<path d="M2 17H4V9H16V17H18V6.35L10 3.15L2 6.35V17ZM0 19V5L10 1L20 5V19H14V11H6V19H0ZM7 19V17H9V19H7ZM9 16V14H11V16H9ZM11 19V17H13V19H11Z" fill="#D41320"/>
<path d="M2 17H4V9H16V17H18V6.35L10 3.15L2 6.35V17ZM0 19V5L10 1L20 5V19H14V11H6V19H0ZM7 19V17H9V19H7ZM9 16V14H11V16H9ZM11 19V17H13V19H11Z" fill="#D18E4B"/>
<path d="M2 17H4V9H16V17H18V6.35L10 3.15L2 6.35V17ZM0 19V5L10 1L20 5V19H14V11H6V19H0ZM7 19V17H9V19H7ZM9 16V14H11V16H9ZM11 19V17H13V19H11Z" fill="#707070"/>
<path d="M2 17H4V9H16V17H18V6.35L10 3.15L2 6.35V17ZM0 19V5L10 1L20 5V19H14V11H6V19H0ZM7 19V17H9V19H7ZM9 16V14H11V16H9ZM11 19V17H13V19H11Z" fill="#BCBCBC"/>
<path class="warehouse-icon-path" d="M2 17H4V9H16V17H18V6.35L10 3.15L2 6.35V17ZM0 19V5L10 1L20 5V19H14V11H6V19H0ZM7 19V17H9V19H7ZM9 16V14H11V16H9ZM11 19V17H13V19H11Z" fill="#0062A9"/>
<path d="M2 17H4V9H16V17H18V6.35L10 3.15L2 6.35V17ZM0 19V5L10 1L20 5V19H14V11H6V19H0ZM7 19V17H9V19H7ZM9 16V14H11V16H9ZM11 19V17H13V19H11Z" fill="#1E4971"/>
<path d="M2 17H4V9H16V17H18V6.35L10 3.15L2 6.35V17ZM0 19V5L10 1L20 5V19H14V11H6V19H0ZM7 19V17H9V19H7ZM9 16V14H11V16H9ZM11 19V17H13V19H11Z" fill="#2C3F50"/>
<path class="warehouse-icon-path" d="M2 17H4V9H16V17H18V6.35L10 3.15L2 6.35V17ZM0 19V5L10 1L20 5V19H14V11H6V19H0ZM7 19V17H9V19H7ZM9 16V14H11V16H9ZM11 19V17H13V19H11Z" fill="#0062A9"/>
</svg>
</template>

<script>
export default {
  name: 'Warehouse',
  props: {
  }
}
</script>

<style scoped>
</style>
